<template>
  <div>
    <!-- 省区/地办/日期查询区 -->
    <el-row style="margin-left: 80px;margin-top: 10px">
      <el-select v-model="selForm.sel_shengqu_zssy" @change="get_diban_zssy" placeholder="请选择省区"
                 style="margin-left: 20px">
        <el-option v-for="item in options_shengqu_zssy"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="selForm.sel_diban_zssy" placeholder="请选择地办" style="margin-left: 20px">
        <el-option v-for="item in options_diban_zssy"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-date-picker
          v-model="selForm.date_span_zssy"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="margin-left: 20px"
          :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" @click="query_zssy"
                 style="margin-left: 20px;background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;">
        查询
      </el-button>
    </el-row>

    <!-- 报表趋势页签区 -->
    <el-tabs v-model="activeName" style="margin-top: 10px;margin-left: 10px" @tab-click="handleClick">
      <el-tab-pane
        v-for="tab in tabConfig"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
        :lazy="true"
      >
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover" :lazy="tab.cardLazy">
                <el-row :gutter="20">
                  <el-col v-for="chart in tab.charts" :key="chart.id" :span="chart.span">
                    <LineChart
                      :id="chart.id"
                      :path="chart.path"
                      :key="getChartKey(tab.keyRef)"
                      :params="selForm"
                      v-bind="chartSize"
                    ></LineChart>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="疾病数量走势图" name="sixth" :lazy=true>
        <!-- <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-input v-model="selForm.keyword" style="width: 200px;background-color: #4B4F56;color: white;"
                        placeholder="请输入关键词"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit"
                         style="background-color: #2ECD81;border-color: #2ECD81;color:white ">查询
              </el-button>
            </el-form-item>
          </el-form>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <LineChart id="jb_patient_trend" path="jb_patient_trend" :key="selKey" :params="selForm"
                               v-bind="chartSize">
                    </LineChart>
                  </el-col>
                  <el-col :span="12">
                    <LineChart id="jb_cost_trend" path="jb_cost_trend" :key="selKey" :params="selForm"
                               v-bind="chartSize">
                    </LineChart>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import LineChart from '@/views/charts/line.vue'
import moment from "moment-timezone";

const createDefaultRange = () => ([
  moment().subtract(7, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
  moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
]);

const CHART_SIZE = {
  height: '600px',
  width: '100%'
};

const TAB_CONFIG = [
  {
    label: '诊所使用走势图',
    name: 'first',
    keyRef: 'selKey_zssy',
    cardLazy: true,
    charts: [
      { id: 'zssy_online_trend', path: 'zssy_online_trend', span: 12 },
      { id: 'zssy_pad_trend', path: 'zssy_pad_trend', span: 12 },
    ],
  },
  {
    label: '诊所新接入走势图',
    name: 'second',
    keyRef: 'selKey_zsjr',
    cardLazy: false,
    charts: [
      { id: 'zsjr_online_trend', path: 'zsjr_online_trend', span: 12 },
      { id: 'zsjr_pad_trend', path: 'zsjr_pad_trend', span: 12 },
    ],
  },
  {
    label: '开方数量走势图',
    name: 'third',
    keyRef: 'selKey',
    cardLazy: false,
    charts: [
      { id: 'kfsl_trend', path: 'query_area_kfl_trend', span: 12 },
      { id: 'fees_trend', path: 'query_area_fees_trend', span: 12 },
    ],
  },
  {
    label: '医生数量走势图',
    name: 'fourth',
    keyRef: 'selKey',
    cardLazy: false,
    charts: [
      { id: 'doctor_trend', path: 'query_area_doctor_trend', span: 24 },
    ],
  },
  {
    label: '患者数量走势图',
    name: 'fifth',
    keyRef: 'selKey',
    cardLazy: false,
    charts: [
      { id: 'patient_trend', path: 'query_area_patient_trend', span: 24 },
    ],
  },
];

export default {
  components: {
    LineChart,
  },

  data() {
    return {
      // 当前激活的页签，支持路由参数 act 直达
      activeName: this.$route.query.act ? this.$route.query.act : 'first',
      selForm: {
        // 疾病关键词检索
        keyword: "",

        // 开方/费用趋势筛选
        date_span: createDefaultRange(),
        sel_province: '',
        sel_city: '',
        sel_area: '',

        // 诊所新接入趋势筛选
        date_span_zsjr: createDefaultRange(),
        sel_shengqu: '',
        sel_diban: '',

        // 诊所使用趋势筛选
        date_span_zssy: createDefaultRange(),
        sel_shengqu_zssy: '',
        sel_diban_zssy: '',

      },
      // 省区/地办/区域数据选项
      options_province: null,
      options_city: null,
      options_shengqu: null,
      options_diban: null,
      options_shengqu_zssy: null,
      options_diban_zssy: null,
      options_area: null,
      // 图表刷新 key，变更后触发 LineChart 重新渲染
      selKey: '',
      selKey_zssy: '',
      selKey_zsjr: '',
      // 报表页签配置，抽离重复图表结构
      tabConfig: TAB_CONFIG,
      // 统一图表尺寸配置
      chartSize: CHART_SIZE,
      // 懒加载标记：首次进入的页签会触发加载
      load: {
        first: true, // 诊所使用走势图页签已加载
        second: false, // 诊所新接入走势图页签加载状态
        third: false, // 开方数量走势图页签加载状态
        fourth: false, // 医生数量走势图页签加载状态
        fifth: false, // 患者数量走势图页签加载状态
        fydt: false, // 费用动态相关图表加载状态（旧字段保留）
        zssl: false, // 诊所数量相关图表加载状态（旧字段保留）
        kfsl: false, // 开方数量相关图表加载状态（旧字段保留）
        kcl: false, // 开处量相关图表加载状态（旧字段保留）
        ysxg: false, // 医生相关图表加载状态（旧字段保留）
        kfsl_trend_stat: false, // 开方趋势统计加载标记（旧字段保留）
        zsjr_trend_stat: false, // 诊所接入趋势统计加载标记（旧字段保留）
        zssy_trend_stat: false, // 诊所使用趋势统计加载标记（旧字段保留）
        fees_trend_stat: false, // 费用趋势统计加载标记（旧字段保留）
      },
      // 日期快捷选择配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  watch: {
    '$route': function (to, from) {
      if (to != from) {
        // 路由变化时刷新图表
        this.initChart();
      }
    }
  },
  methods: {
    onSubmit() {
      // 更新 key 以触发疾病趋势图刷新
      this.selKey = Date.now();
    },
    getChartKey(keyRef) {
      // 根据配置映射到对应的刷新 key
      return this[keyRef];
    },
    handleClick(tab, event) {
      console.log(event)
      if (this.load[tab.name] === false) {
        // 首次点击时打开懒加载标记
        this.load[tab.name] = true
      }
    },
    query_area_kfl() {
      // 刷新开方/费用趋势图
      this.selKey = Date.now();
    },
    query_zsjr() {
      // 同步诊所新接入的筛选项并刷新趋势图
      this.selKey_zsjr = Date.now();
      this.syncZssyFilters();
    },
    query_zssy() {
      // 刷新诊所使用趋势，并联动其他趋势条件
      this.selKey_zssy = Date.now();
      this.query_area_kfl();
      this.query_zsjr();
    },
    syncZssyFilters() {
      // 复用诊所使用筛选条件到其他趋势图
      this.selForm.date_span_zsjr = this.selForm.date_span_zssy;
      this.selForm.date_span = this.selForm.date_span_zssy;
      this.selForm.sel_diban_zsjr = this.selForm.sel_diban_zssy;
      this.selForm.sel_diban = this.selForm.sel_diban_zssy;
      this.selForm.sel_shengqu_zsjr = this.selForm.sel_shengqu_zssy;
      this.selForm.sel_shengqu = this.selForm.sel_shengqu_zssy;
    },
    get_province() {
      // 省份下拉数据
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_province").then((res) => {
        this.options_province = res.data.data
      })
    },
    get_city() {
      // 省份变化后加载城市数据
      this.selForm.sel_city = ''
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_city?province_id=" + this.selForm.sel_province).then((res) => {
        this.options_city = res.data.data
      })
    },

    get_shengqu() {
      // 省区下拉数据
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        this.options_shengqu = res.data.data
        this.options_shengqu_zssy = res.data.data
      })
    },
    get_diban() {
      // 省区变化后加载地办数据（新接入趋势）
      this.selForm.sel_diban = ''
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_diban?province_id=" + this.selForm.sel_shengqu).then((res) => {
        this.options_diban = res.data.data
      })
    },
    get_diban_zssy() {
      // 省区变化后加载地办数据（使用趋势）
      this.selForm.sel_diban_zssy = ''
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_diban?province_id=" + this.selForm.sel_shengqu_zssy).then((res) => {
        this.options_diban_zssy = res.data.data
      })
    },
    getDescViewData(){
      // 批量初始化页面下拉数据（保留旧逻辑）
      this.$store.commit('showLoading', { 
        subText: '请稍候...'
      })
      let get_province = new Promise((resolve, reject) => {
          this.$http.get(process.env.VUE_APP_API_HOST + "/get_province").then((res) => {
          this.options_province = res.data.data
          resolve(res);
        }).catch(err =>{
          reject(err)
        })
      })
      let get_shengqu = new Promise((resolve, reject) => {
          this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
          this.options_shengqu = res.data.data
          this.options_shengqu_zssy = res.data.data
          resolve(res);
        }).catch(err =>{
          reject(err)
        })
      })
      Promise.all([get_province, get_shengqu]).then(() =>{
        this.$store.commit('hideLoading')
      })
               
    }
  },
  mounted() {
    // this.getDescViewData()
    this.get_province();
    this.get_shengqu();
    this.query_area_kfl();
  }
}
</script>

<style scoped>
.el-form {
  text-align: center;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}

/deep/ .el-tabs__item {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__item.is-active {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__active-bar {
  background-color: #68F5B9 !important;

}


</style>
